// 语言列表： 顺序参考 https://g309cb26d83.larksuite.com/wiki/FFZuwrfJ6iKbYLkOUEGu6ilYsbg
// 简体中文、繁体中文、英语、泰语、越南语、印度尼西亚语、马来语、印地语、日语、葡萄牙语、西班牙语、俄语、韩语、缅甸语、柬埔寨语（高棉语）、菲律宾语、法语、老挝语、荷兰语、德语、阿拉伯语、孟加拉语、土耳其语、波斯语、意大利语、波兰语、祖鲁语
const LANGUAGE_CONFIGURE = [
  { label: '中文简体', value: 'zh' }, //简体中文
  { label: '繁體中文', value: 'cht' }, //繁体中文
  { label: 'English', value: 'en' }, //英语
  { label: 'แบบไทย', value: 'th' }, //泰语
  { label: 'Tiếng Việt', value: 'vi' }, //越南语
  { label: 'Bahasa Indonesia', value: 'id' }, //印度尼西亚语
  { label: 'Malay', value: 'ms' }, //马来西亚语
  { label: 'हिन्दी', value: 'hi' }, //印地语
  { label: '日本語', value: 'ja' }, //日语
  { label: 'Português', value: 'pt' }, //葡萄牙
  { label: 'Español', value: 'es' }, //西班牙
  { label: 'русский', value: 'ru' }, //俄语
  { label: '한국어', value: 'ko' }, //韩语
  { label: 'မြန်မာ', value: 'my' }, //缅甸语
  { label: 'ភាសាខ្មែរ', value: 'km' }, //柬埔寨语（高棉语）
  { label: 'Filipino', value: 'fil' }, //菲律宾语
  { label: 'Français', value: 'fr' }, //法语
  { label: 'ລາວ', value: 'lo' }, //老挝语
  { label: 'Nederlands', value: 'nl' }, //荷兰语
  { label: 'Deutsch', value: 'de' }, //德语
  { label: 'العربية', value: 'ar' }, //阿拉伯语
  { label: 'বাংলা', value: 'bn' }, //孟加拉语
  { label: 'Türkçe', value: 'tr' }, //土耳其语
  { label: 'فارسی', value: 'fa' }, //波斯语
  { label: 'Italiano', value: 'it' }, //意大利语
  { label: 'Polski', value: 'pl' }, //波兰语
  { label: 'isiZulu', value: 'zu' } //祖鲁语
];

//简体中文
const ZH_CAHNGE_NIFO = {
  title: '切换语言',
  okStr: '确定',
  cancelStr: '取消',
  contentStr: '是否将目标语言切换为简体中文？',
  label: LANGUAGE_CONFIGURE[0].label,
  value: LANGUAGE_CONFIGURE[0].value
};
// 繁体中文
const ZH_TW_CHANGE_INFO = {
  title: '更改語言',
  okStr: '確認',
  cancelStr: '取消',
  contentStr: '您想要將語言更改為繁體中文嗎？',
  label: LANGUAGE_CONFIGURE[1].label,
  value: LANGUAGE_CONFIGURE[1].value
};
//英文
const EN_CHANGE_INFO = {
  title: 'Update language',
  okStr: 'Sure',
  cancelStr: 'Cancel',
  contentStr:
    'Are you sure you want to update the language to English？The translation function is currently in beta. Only the chat page is in English.',
  label: LANGUAGE_CONFIGURE[2].label,
  value: LANGUAGE_CONFIGURE[2].value
};
// 泰语
const TH_CHANGE_INFO = {
  title: 'เปลี่ยนภาษา',
  okStr: 'แน่นอน',
  cancelStr: 'ยกเลิก',
  contentStr:
    'คุณแน่ใจหรือไม่ว่าต้องการอัปเดตภาษาเป็นภาษาไทย ขณะนี้คุณสมบัติการแปลอยู่ในรุ่นเบต้าเฉพาะหน้าแชทที่เป็นภาษาไทย',
  label: LANGUAGE_CONFIGURE[3].label,
  value: LANGUAGE_CONFIGURE[3].value
};
//越南语
const VI_CHANGE_INFO = {
  title: 'Chuyển đổi ngôn ngữ',
  okStr: 'Xác nhận',
  cancelStr: 'Hủy bỏ',
  contentStr:
    'Bạn có chắc chắn muốn cập nhật ngôn ngữ sang tiếng Việt không? Tính năng dịch hiện đang trong giai đoạn thử nghiệm. Chỉ có trang chat là tiếng Việt.',
  label: LANGUAGE_CONFIGURE[4].label,
  value: LANGUAGE_CONFIGURE[4].value
};
// 印度尼西亚语
const ID_CHANGE_INFO = {
  title: 'Ubah Bahasa',
  okStr: 'Konfirmasi',
  cancelStr: 'Batal',
  contentStr: 'Apakah Anda ingin mengubah bahasa ke Bahasa Indonesia?',
  label: LANGUAGE_CONFIGURE[5].label,
  value: LANGUAGE_CONFIGURE[5].value
};
// 马来西亚
const MY_CAHNGE_INFO = {
  title: 'Tukar Bahasa',
  okStr: 'Sahkan',
  cancelStr: 'Batal',
  contentStr: 'Adakah anda mahu menukar bahasa sasaran kepada Bahasa Malaysia?',
  label: LANGUAGE_CONFIGURE[6].label,
  value: LANGUAGE_CONFIGURE[6].value
};
// 印地语
const HI_CHANGE_INFO = {
  title: 'भाषा बदलें',
  okStr: 'पुष्टि करें',
  cancelStr: 'रद्द करें',
  contentStr: 'क्या आप हिंदी में भाषा बदलना चाहते हैं?',
  label: LANGUAGE_CONFIGURE[7].label,
  value: LANGUAGE_CONFIGURE[7].value
};
// 日语
const JA_CHANGE_INFO = {
  title: '言語を変更',
  okStr: '確認',
  cancelStr: 'キャンセル',
  contentStr: '言語を日本語に変更しますか？',
  label: LANGUAGE_CONFIGURE[8].label,
  value: LANGUAGE_CONFIGURE[8].value
};
// 葡萄牙
const PT_CHANGE_INFO = {
  title: 'Mudar de idioma',
  okStr: 'Confirmar',
  cancelStr: 'Cancelar',
  contentStr: 'Deseja mudar o idioma de destino para português?',
  label: LANGUAGE_CONFIGURE[9].label,
  value: LANGUAGE_CONFIGURE[9].value
};
// 西班牙语
const ES_CHANGE_INFO = {
  title: 'Cambiar idioma',
  okStr: 'Confirmar',
  cancelStr: 'Cancelar',
  contentStr: '¿Desea cambiar el idioma a Español?',
  label: LANGUAGE_CONFIGURE[10].label,
  value: LANGUAGE_CONFIGURE[10].value
};
// 俄语
const RU_CHANGE_INFO = {
  title: 'Изменить язык',
  okStr: 'Подтвердить',
  cancelStr: 'Отмена',
  contentStr: 'Вы хотите изменить язык на Русский?',
  label: LANGUAGE_CONFIGURE[11].label,
  value: LANGUAGE_CONFIGURE[11].value
};
// 韩国
const KR_CAHNGE_INFO = {
  title: '언어 변경',
  okStr: '확실하다',
  cancelStr: '취소',
  contentStr: '목표 언어를 한국어로 변경할까요? 한국어로 어떻게 번역합니까?',
  label: LANGUAGE_CONFIGURE[12].label,
  value: LANGUAGE_CONFIGURE[12].value
};
//缅甸语
const MM_CHANGE_INFO = {
  title: 'ဘာသာပြန်ရန်',
  okStr: 'အတည်ပြုပါ',
  cancelStr: 'ဖျက်သိမ်းပါ',
  contentStr: 'သင်သည် မြန်မာဘာသာသို့ ဘာသာပြန်လိုသလား?',
  label: LANGUAGE_CONFIGURE[13].label,
  value: LANGUAGE_CONFIGURE[13].value
};
// 柬埔寨语（高棉语）
const KM_CHANGE_INFO = {
  title: 'ប្តូរភាសា',
  okStr: 'បញ្ជាក់',
  cancelStr: 'បោះបង់',
  contentStr: 'តើអ្នកចង់ប្តូរភាសាទៅជាភាសាខ្មែរឬ?',
  label: LANGUAGE_CONFIGURE[14].label,
  value: LANGUAGE_CONFIGURE[14].value
};
// 菲律宾语
const PH_CHANGE_INFO = {
  title: 'Palitan ang wika',
  okStr: 'Kumpirmahin',
  cancelStr: 'Kanselahin',
  contentStr: 'Nais mo bang palitan ang wika sa Filipino?',
  label: LANGUAGE_CONFIGURE[15].label,
  value: LANGUAGE_CONFIGURE[15].value
};
// 法语
const FR_CHANGE_INFO = {
  title: 'Changer de langue',
  okStr: 'Confirmer',
  cancelStr: 'Annuler',
  contentStr: 'Voulez-vous changer la langue en Français?',
  label: LANGUAGE_CONFIGURE[16].label,
  value: LANGUAGE_CONFIGURE[16].value
};
// 老挝语
const LO_CHANGE_INFO = {
  title: 'ປ່ຽນພາສາ',
  okStr: 'ຢືນຢັນ',
  cancelStr: 'ຍົກເລີກ',
  contentStr: 'ທ່ານຕ້ອງການປ່ຽນພາສາໄປເປັນພາສາລາວຫຼືບໍ?',
  label: LANGUAGE_CONFIGURE[17].label,
  value: LANGUAGE_CONFIGURE[17].value
};
// 荷兰语
const NL_CHANGE_INFO = {
  title: 'Taal wijzigen',
  okStr: 'Bevestigen',
  cancelStr: 'Annuleren',
  contentStr: 'Wilt u de taal wijzigen naar Nederlands?',
  label: LANGUAGE_CONFIGURE[18].label,
  value: LANGUAGE_CONFIGURE[18].value
};
// 德语
const DE_CHANGE_INFO = {
  title: 'Sprache ändern',
  okStr: 'Bestätigen',
  cancelStr: 'Abbrechen',
  contentStr: 'Möchten Sie die Sprache auf Deutsch ändern?',
  label: LANGUAGE_CONFIGURE[19].label,
  value: LANGUAGE_CONFIGURE[19].value
};
// 阿拉伯语
const AR_CHANGE_INFO = {
  title: 'تغيير اللغة',
  okStr: 'تأكيد',
  cancelStr: 'إلغاء',
  contentStr: 'هل تريد تغيير اللغة إلى العربية؟',
  label: LANGUAGE_CONFIGURE[20].label,
  value: LANGUAGE_CONFIGURE[20].value
};
// 孟加拉语
const BN_CHANGE_INFO = {
  title: 'ভাষা পরিবর্তন করুন',
  okStr: 'ঠিক আছে',
  cancelStr: 'বাতিল করুন',
  contentStr: 'আপনি কি লক্ষ্যভাষাকে সরল চীনায় পরিবর্তন করতে চান?',
  label: LANGUAGE_CONFIGURE[21].label,
  value: LANGUAGE_CONFIGURE[21].value
};
// 土耳其语
const TR_CHANGE_INFO = {
  title: 'Dili Değiştir',
  okStr: 'Onayla',
  cancelStr: 'İptal',
  contentStr: 'Dili Türkçe olarak değiştirmek istiyor musunuz?',
  label: LANGUAGE_CONFIGURE[22].label,
  value: LANGUAGE_CONFIGURE[22].value
};
// 波斯语
const FA_CHANGE_INFO = {
  title: 'تغییر زبان',
  okStr: 'تایید',
  cancelStr: 'لغو',
  contentStr: 'آیا می‌خواهید زبان را به فارسی تغییر دهید؟',
  label: LANGUAGE_CONFIGURE[23].label,
  value: LANGUAGE_CONFIGURE[23].value
};
// 意大利语
const IT_CHANGE_INFO = {
  title: 'Cambia lingua',
  okStr: 'Conferma',
  cancelStr: 'Annulla',
  contentStr: 'Vuoi cambiare la lingua in Italiano?',
  label: LANGUAGE_CONFIGURE[24].label,
  value: LANGUAGE_CONFIGURE[24].value
};
// 波兰语
const PL_CHANGE_INFO = {
  title: 'Zmień język',
  okStr: 'Potwierdź',
  cancelStr: 'Anuluj',
  contentStr: 'Czy chcesz zmienić język na Polski?',
  label: LANGUAGE_CONFIGURE[25].label,
  value: LANGUAGE_CONFIGURE[25].value
};
// 祖鲁语
const ZU_CHANGE_INFO = {
  title: 'Shintsha ulimi',
  okStr: 'Qinisekisa',
  cancelStr: 'Khansela',
  contentStr: 'Ufuna ukushintsha ulimi lube isiZulu?',
  label: LANGUAGE_CONFIGURE[26].label,
  value: LANGUAGE_CONFIGURE[26].value
};

export default {
  LANGUAGE_CONFIGURE,
  ZH_CAHNGE_NIFO,
  ZH_TW_CHANGE_INFO,
  EN_CHANGE_INFO,
  TH_CHANGE_INFO,
  VI_CHANGE_INFO,
  ID_CHANGE_INFO,
  MY_CAHNGE_INFO,
  HI_CHANGE_INFO,
  JA_CHANGE_INFO,
  PT_CHANGE_INFO,
  ES_CHANGE_INFO,
  RU_CHANGE_INFO,
  KR_CAHNGE_INFO,
  MM_CHANGE_INFO,
  KM_CHANGE_INFO,
  PH_CHANGE_INFO,
  FR_CHANGE_INFO,
  LO_CHANGE_INFO,
  NL_CHANGE_INFO,
  DE_CHANGE_INFO,
  AR_CHANGE_INFO,
  BN_CHANGE_INFO,
  TR_CHANGE_INFO,
  FA_CHANGE_INFO,
  IT_CHANGE_INFO,
  PL_CHANGE_INFO,
  ZU_CHANGE_INFO
};
